var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgStarSignClose(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.318 2.68161C3.14227 2.50587 2.85734 2.50587 2.68161 2.68161C2.50587 2.85734 2.50587 3.14227 2.68161 3.318L8.36341 8.9998L2.68161 14.6816C2.50587 14.8573 2.50587 15.1423 2.68161 15.318C2.85734 15.4937 3.14227 15.4937 3.318 15.318L8.9998 9.6362L14.6816 15.318C14.8573 15.4937 15.1423 15.4937 15.318 15.318C15.4937 15.1423 15.4937 14.8573 15.318 14.6816L9.6362 8.9998L15.318 3.318C15.4937 3.14227 15.4937 2.85734 15.318 2.68161C15.1423 2.50587 14.8573 2.50587 14.6816 2.68161L8.9998 8.36341L3.318 2.68161Z",
    fill: "white",
    fillOpacity: 0.6
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStarSignClose);
export default __webpack_public_path__ + "static/media/star_sign_close.aa7a1e539037de67ff472eba65af0d62.svg";
export { ForwardRef as ReactComponent };